/**
 * Trace dashboard widget API + settings UI: set NEXT_PUBLIC_DEBUG_WIDGETS=1 in .env.local
 * and restart `next dev`. Filter DevTools console by `[widgets`.
 */

export function widgetsDebugEnabled(): boolean {
  return (
    typeof process !== "undefined" &&
    process.env.NEXT_PUBLIC_DEBUG_WIDGETS === "1"
  );
}

export function widgetsDebug(scope: string, ...args: unknown[]): void {
  if (!widgetsDebugEnabled()) return;
  console.log(`[widgets:${scope}]`, ...args);
}
